import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { Description } from 'components/Typography'
import { GreyButton } from 'components/Button'
import { RedLogo } from 'components/Image'

const RegisterErrorTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <RedLogo />
      <Spacer size={100} />
      <h2 className={`${text.font_bold} ${text.font_large} ${text.align_center}`}>リンクの有効期限が切れています。</h2>
      <Spacer size={24} />
      <Description
        align={'center'}
        description={
          '恐れ入りますが、招待してくれた方にご連絡いただき\n再度招待リンクを発行していただきますよう\nお願いいたします。'
        }
      />
      <Spacer size={48} />
      <GreyButton
        label={'お問い合わせ'}
        onClick={() => window.open('https://sacrisupport.zendesk.com/hc/ja/requests/new')}
        size={'medium'}
        type={'outlined'}
      />
    </div>
  )
}

export default RegisterErrorTemplate
